/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import FavoritesPage from '../../../components/FavoritesPage';

export default function FavoritesRoute({ params, ...rest }) {
  return <FavoritesPage locale={params.locale} {...rest} />;
}
